const supportedFormats = {
  'dd MMM yyyy': 'dd MMM yyyy',
  'dd / MM / yyyy': 'dd / MM / yyyy'
};

export default supportedFormats;
